function createCanvas(): never {
  throw new Error(
    'pdf.js Node canvas backend is not available in the browser.',
  );
}

export default {
  createCanvas,
};
